class CtxCustomScrollbarController {
    constructor() {

    }

    callbackWhileScrolling(scrollEl) {
        if (angular.isUndefined(this.whileScrollingFn)) return;
        this.scrollEl = scrollEl;
        if (typeof this.whileScrollingFn === 'function') this.whileScrollingFn();
    }

    callbackOnScroll(scrollEl) {
        if (angular.isUndefined(this.onScrollFn)) return;
        this.scrollEl = scrollEl;
        if (typeof this.onScrollFn === 'function') this.onScrollFn();
    }

    callbackOnScrollUpdate() {
        if (angular.isUndefined(this.onUpdateFn)) return;
        if (typeof this.onUpdateFn === 'function') this.onUpdateFn();
    }
}
class ctxCustomScrollbarDirective {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.restrict = 'A';
        this.scope = true;
        this.controller = CtxCustomScrollbarController;
        this.controllerAs = 'scrollbarCtrl';
        this.bindToController = {
            whileScrollingFn: '&?',
            onScrollFn: '&?',
            scrollEl: '=?',
            onUpdateFn:'&?',
        }
    }

    link(scope, element, attrs) {
        this.$timeout(() => {
            element.mCustomScrollbar({
                theme: "minimal-dark",
                mouseWheelPixels: 90,
                scrollInertia: 500,
                axis: attrs.ctxCustomScrollBar === '' ? 'xy' : attrs.ctxCustomScrollBar,
                advanced: {
                    updateOnContentResize: true,
                    autoExpandHorizontalScroll: true
                },
                callbacks: {
                    onScrollStart: function() {
                        let temp = element.find('.tooltip-layout-class');
                        if(temp.length) {
                            temp.remove();
                        }
                    },
                    whileScrolling: function () {
                        scope.scrollbarCtrl.callbackWhileScrolling(this.mcs);
                    },
                    onScroll: function () {
                        scope.scrollbarCtrl.callbackOnScroll(this.mcs);
                    },
                    onUpdate:function(){
                        scope.scrollbarCtrl.callbackOnScrollUpdate();
                    }
                }
            });
            element.trigger('customScroll:initialized');
        }, 0);
    }

    static directiveFactory($timeout) {
        return new ctxCustomScrollbarDirective($timeout);
    }
}

ctxCustomScrollbarDirective.directiveFactory.$inject = ['$timeout'];

module.exports = ctxCustomScrollbarDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/utils/ctxCustomScrollBar.directive.js